export const REQUEST_ACTIONS = {
  DELETE: "deleted",
  CREATE: "created",
  UPDATE: "updated",
};

export const GENERIC_ERROR_MESSAGE = "Unexpected error";

export const getSuccessActionRequestMessage = (entityName, action) =>
  `The ${entityName} was successfully ${action}`;

export const getSuccessCreationRequestMessage = (entityName) =>
  getSuccessActionRequestMessage(entityName, REQUEST_ACTIONS.CREATE);

export const getSuccessDeletionRequestMessage = (entityName) =>
  getSuccessActionRequestMessage(entityName, REQUEST_ACTIONS.DELETE);

export const getSuccessUpdateRequestMessage = (entityName) =>
  getSuccessActionRequestMessage(entityName, REQUEST_ACTIONS.UPDATE);

export const getErrorMessageFromRequestError = (error) => {
  let message = `${GENERIC_ERROR_MESSAGE}`;

  const dataErrorResponse = error?.response?.data;

  if (dataErrorResponse) {
    if (dataErrorResponse?.errors?.length)
      message = dataErrorResponse?.errors?.toString();
    else if (dataErrorResponse?.warnings)
      message = dataErrorResponse?.warnings?.toString();
  }

  return message;
};
